import { render, staticRenderFns } from "./CTContentItem.vue?vue&type=template&id=22033f36&scoped=true"
import script from "./CTContentItem.vue?vue&type=script&lang=js"
export * from "./CTContentItem.vue?vue&type=script&lang=js"
import style0 from "./CTContentItem.vue?vue&type=style&index=0&id=22033f36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22033f36",
  null
  
)

export default component.exports